import style from './TreeNavigation.module.css';

import DeleteIcon from 'assets/svg/delete-01.svg';
import EditIcon from 'assets/svg/edit-01.svg';
import FavoriteIcon from 'assets/svg/star2-01.svg';
import FavoriteActiveIcon from 'assets/svg/star-01.svg';

import Tree from 'widgets/Tree';
import { treeStore } from 'store/mobx/tree.store';
import {
  deleteStorage,
  getStorageChildren,
  getStoragesV2,
  setFavorite,
} from 'services/storage.services';
import { useListDrawerContext } from '../ListDrawerProvider';
import Icon from 'ui/Icon';
import { address_server_short, PUBLIC_ASSETS } from 'config';
import useAlert from 'hooks/useAlert';
import { deletePack } from 'services/pucks.services';
import { useEffect, useState } from 'react';
import ManageStorageModal from 'components/Tabs/StorageTabPage/ManageStorageModal';
import ManagePackModal from 'components/Tabs/StorageTabPage/ManagePackModal';
import TreeDrawerToolbar from '../TreeDrawerToolbar';
import { observer } from 'mobx-react-lite';

const TreeNavigation = observer(() => {
  const { reset } = treeStore;
  const { setSelected } = useListDrawerContext();
  const { showAlert } = useAlert();
  const [treeKey, setTreeKey] = useState(0);

  const [modal, setModal] = useState({
    open: false,
    item: null,
  });

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);

  const favoriteHandler = async (item) => {
    const res = await setFavorite(item.id, item.entity);
    if (res?.success) {
      item.favorite = !item.favorite;
      setTreeKey((prev) => prev + 1);
    } else showAlert(`Не удалось установить элемент избранным!`, 'error');
  };

  const editHandler = (item) => {
    setModal({ open: true, item: item });
  };

  const deleteHandler = (item) => {
    showAlert(
      `Вы действительно хотите удалить ${item.entity === 'storage_pack' ? 'штатив' : 'хранилище'}?`,
      'sure',
      () => deleteFunc(item),
    );
  };

  const deleteFunc = async (item) => {
    if (item.entity === 'storage_pack') {
      const res = await deletePack(item.id);
      if (res.success) {
        setTreeKey((prev) => prev + 1);
        // mode.setType({ mode: 'view', item: '' });
      } else {
        if (res.error_code === 2008) {
          showAlert(`Штатив привязан, либо имеет образцы`, 'info');
        }
      }
    } else {
      const res = await deleteStorage(item.id);

      if (res.success) {
        setTreeKey((prev) => prev + 1);
        // mode.setType({ mode: 'view', item: '' });
      } else {
        if (res.error_code === 2008) {
          showAlert(`Хранилище не пустое`, 'info');
        }
      }
    }
  };

  const handleModalClose = (result) => {
    if (result.item) {
      setTreeKey((prev) => prev + 1);
    }
    setModal({ open: false, item: null });
  };

  return (
    <div className={style.container}>
      <TreeDrawerToolbar />
      <div
        style={{
          paddingLeft: '1rem',
          height: '100%',
          overflowY: 'auto',
        }}
      >
        <Tree
          key={treeKey}
          store={treeStore}
          handlerLoadData={getStoragesV2}
          loadChildren={(nodeId, item, query) => getStorageChildren(nodeId, query)}
          handlerNodeHasChildren={(item) => item.hasChildren}
          onNodeClick={(node) => {
            setSelected(node);
          }}
          actionButtons={(item) => (
            <div
              style={{
                marginLeft: 'auto',
                display: 'flex',
                gap: '0.25rem',
              }}
            >
              <Icon
                src={!item?.favorite ? FavoriteIcon : FavoriteActiveIcon}
                onClick={() => favoriteHandler(item)}
              />
              <Icon src={EditIcon} onClick={() => editHandler(item)} />
              <Icon src={DeleteIcon} onClick={() => deleteHandler(item)} />
            </div>
          )}
          defaultIcon={({ ...rest }) => {
            const { is_empty } = rest;
            return (
              <Icon
                className={style.pack}
                style={{
                  backgroundColor: is_empty ? 'var(--color-brand)' : '#c27e00',
                }}
                src={address_server_short + PUBLIC_ASSETS + 'icons/pack.svg'}
              />
            );
          }}
          nodeKeyConfig={{
            fields: ['id', 'entity'],
            separator: '_',
          }}
        />
      </div>
      {modal.open && modal.item.entity === 'storage_pack' && (
        <ManagePackModal
          data={modal.item}
          open={modal.open}
          onClose={handleModalClose}
          id={modal.item.id}
        />
      )}
      {modal.open && modal.item.entity === 'storage' && (
        <ManageStorageModal
          open={modal.open}
          open={modal.open}
          onClose={handleModalClose}
          id={modal.item.id}
        />
      )}
    </div>
  );
});

export default TreeNavigation;
